import { SponsoredEvents } from './sponsored-events';
import { EventsAttendees } from './events-attendees';

export interface EventDetails {
  sponsoring: SponsoredEvents;
  attending: EventsAttendees;
}
